import { render, staticRenderFns } from "./KeywordFilter.vue?vue&type=template&id=397897d2"
import script from "./KeywordFilter.vue?vue&type=script&lang=js"
export * from "./KeywordFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397897d2')) {
      api.createRecord('397897d2', component.options)
    } else {
      api.reload('397897d2', component.options)
    }
    module.hot.accept("./KeywordFilter.vue?vue&type=template&id=397897d2", function () {
      api.rerender('397897d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/filters/KeywordFilter.vue"
export default component.exports